// removed by extract-text-webpack-plugin
module.exports = {"main":"src-components-Carousel----carousel-module---main---2_vJr","link":"src-components-Carousel----carousel-module---link---1vciH","right":"src-components-Carousel----carousel-module---right---Upzx_","left":"src-components-Carousel----carousel-module---left---3GNp5"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Carousel/carousel.module.css
// module id = 671
// module chunks = 35783957827783